module.exports = __webpack_public_path__ + "img/step07_a_stand_power_bottom_cross_fix_screws.630f3a61.png";